import TAppVersionAdd from './index.vue';

TAppVersionAdd.install = app => {
  app.component(TAppVersionAdd.name, TAppVersionAdd);
};

export default TAppVersionAdd;
